/* eslint-disable prefer-destructuring */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import {
  CostModel,
  CustomerModel,
  MeasureUnit,
  ProductModel,
  ProductStockModel,
  PurchaseOrderModel,
  StockTransferProductModel,
  TaxRateModel,
  VendorModel,
} from "../../../../Utils/Models";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../../../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../../../Utils/Vocabulary";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import {
  handleChangeAutocomplete,
  onChangeTextField,
} from "../../../../Utils/Utils";
import ProductsAutocomplete from "../../ProductsAutocomplete";
import ProductsList from "../StockManagement/ProductsList";
import { PurchaseOrderStatuses } from "../../../../Utils/AutocompleteUtils";
import useCustomMemo from "../../../GenericComponents/useCustomMemo";
import { getData } from "../../../../Services/getData";
import { urlEnum } from "../../../../Utils/UrlEnum";
import { postData } from "../../../../Services/postData";
import { toast } from "react-toastify";

type PurchaseOrderProps = {
  editPurchaseOrder: PurchaseOrderModel | null;
  open: boolean;
  addOrUpdatePurchaseOrder: (inventory: PurchaseOrderModel | null) => void;
  onClose: () => void;
};

export default function PurchaseOrder(props: PurchaseOrderProps) {
  const { editPurchaseOrder, open, addOrUpdatePurchaseOrder, onClose } = props;
  const ref: any = useRef();
  const cache = useCustomMemo();
  const inventories = cache.inventories || [];
  const [purchaseOrder, setPurchaseOrder] = useState<PurchaseOrderModel>(
    new PurchaseOrderModel()
  );
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [invoices, setInvoices] = useState<Array<CostModel>>([]);
  const [invoiceProducts, setInvoiceProducts] = useState<
    StockTransferProductModel[]
  >([]);
  const [vatList, setVatList] = useState<Array<TaxRateModel>>([]);
  const [vendorList, setVendorList] = useState<Array<VendorModel>>([]);
  const [mainUser, setMainUser] = useState(new CustomerModel());

  useEffect(() => {
    const getInvoices = async () => {
      const response = await getData(`${urlEnum.costs}`);
      if (response) {
        setInvoices(response.data);
      }
    };
    getInvoices();

    const getTaxRates = async () => {
      const response = await getData(`${urlEnum.taxRates}`);
      if (response) {
        setVatList(response.data.result);
      }
    };
    getTaxRates();

    const getVendors = async () => {
      const response = await getData(`${urlEnum.customers}/type/vendors`);
      if (response) {
        setVendorList(response.data.result);
      }
    };
    getVendors();

    const getMainUser = async () => {
      const mainCustomer: CustomerModel = (
        await getData(`${urlEnum.customers}/users/mainUser`)
      ).data;
      setMainUser(mainCustomer);
    };
    getMainUser();
  }, []);

  useEffect(() => {
    const fetchAndFilterProducts = async () => {
      setPurchaseOrder({
        ...purchaseOrder,
        products: [],
      });
      setInvoiceProducts([]);
      const invoice = purchaseOrder.invoice;
      if (invoice && invoice._id) {
        try {
          const response = await getData(
            `${urlEnum.products}/getByInvoice/${invoice.invoiceId}`
          );
          const isProductsInDb: ProductModel[] = response.data || [];

          const items = invoice.items;
          const products: StockTransferProductModel[] = [];

          if (items.length > 0) {
            items.forEach((item) => {
              const alreadyExists = isProductsInDb.some(
                (prod) =>
                  prod.name === item.name &&
                  prod.invoiceId === invoice.invoiceId
              );

              if (!alreadyExists) {
                const product = new ProductModel();
                const productStock = new ProductStockModel();
                const stockTransferProduct = new StockTransferProductModel();

                productStock.inventory = purchaseOrder.inventory;
                productStock.percentageVAT = item.VATvalue;
                productStock.pricePerQuantity =
                  item.totalWithoutVAT / item.quantity;
                productStock.quantity = item.quantity;
                productStock.totalPrice = item.totalWithoutVAT;

                product.name = item.name;
                product.invoiceId = invoice.invoiceId;
                product.inventories[0] = productStock;

                const pricePerQuantity = item.totalWithoutVAT / item.quantity;
                stockTransferProduct.product = product;
                stockTransferProduct.pricePerQuantity = pricePerQuantity;
                stockTransferProduct.quantity = item.quantity;

                stockTransferProduct.totalPrice =
                  pricePerQuantity * item.quantity +
                  (pricePerQuantity * item.quantity * item.VATvalue) / 100;

                stockTransferProduct.VATvalue =
                  vatList.find((vat) => Number(vat.value) === item.VATvalue) ||
                  new TaxRateModel();

                products.push(stockTransferProduct);
                setInvoiceProducts((prev) => [...prev, stockTransferProduct]);
              }
            });
          }

          setPurchaseOrder({
            ...purchaseOrder,
            products: [...purchaseOrder.products, ...products],
          });
        } catch (error) {
          console.error("Failed to fetch products by invoice:", error);
        }
      }
    };

    fetchAndFilterProducts();
  }, [purchaseOrder.invoice]);

  /**
   *
   */
  useEffect(() => {
    if (editPurchaseOrder) {
      setPurchaseOrder(editPurchaseOrder);
    } else {
      setPurchaseOrder(new PurchaseOrderModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editPurchaseOrder]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  /**
   * Add new product in stock transfer
   */
  async function addNewProductInStockTransfer(event: any, value: any) {
    if (value) {
      const products = [...purchaseOrder.products];
      const inventory = value.inventories.find(
        (inv: any) =>
          purchaseOrder.inventory &&
          inv.inventory._id === purchaseOrder.inventory._id
      );
      const defaultVAT =
        vatList.find((v) => v.defaultValue === true) || new TaxRateModel();
      const newProduct: StockTransferProductModel = {
        product: value,
        quantity: inventory ? inventory.quantity : 0,
        totalPrice: inventory ? inventory.totalPrice : 0,
        pricePerQuantity: inventory ? inventory.pricePerQuantity : 0,
        status: PurchaseOrderStatuses.open,
        measureUnit: value.measureUnit || new MeasureUnit(),
        VATvalue: value.vat || defaultVAT,
        maxQuantity: inventory ? inventory.quantity : 0,
        markup: value.markup ? value.markup : mainUser.commercialMarkup,
      };
      products.push(newProduct);
      setPurchaseOrder({ ...purchaseOrder, products });
    }
  }

  async function addProductsFromInvoice(purchaseOrder: PurchaseOrderModel) {
    if (purchaseOrder) {
      for (let i = 0; i < purchaseOrder.products.length; i++) {
        const stockTransfer = purchaseOrder.products[i];
        if (!stockTransfer.product?._id) {
          const response = await postData(
            `${urlEnum.products}`,
            stockTransfer.product
          );
          const postProduct: ProductModel = response.data.result;
          const inventory = postProduct.inventories[0]?.inventory;
          const formatData = new ProductModel();
          if (!inventory) {
            throw new Error("Inventory is null for the posted product.");
          }
          formatData._id = postProduct._id;
          formatData.code = postProduct.code;
          formatData.name = postProduct.name;
          formatData.price = postProduct.price;
          formatData.images = postProduct.images;
          formatData.inventories = [postProduct.inventories[0]];
          formatData.variants = postProduct.variants;
          formatData.vat = postProduct.vat;

          // Replace the product with the formatted one
          stockTransfer.product = formatData;
        }
      }
    }
  }

  /**
   *
   * @param event
   * @param index
   */
  function onChangeProducts(products: any) {
    setPurchaseOrder({ ...purchaseOrder, products });
  }

  return (
    <ValidatorForm
      ref={ref}
      onSubmit={async () => {
        if (mainUser._id) {
          await addProductsFromInvoice(purchaseOrder);
          addOrUpdatePurchaseOrder(purchaseOrder);
        }else{
          toast.error("No main user");
        }
      }}
    >
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.purchaseOrder}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Grid container spacing={2} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="purchaseOrderNumber"
              name="purchaseOrderNumber"
              label={Vocabulary.purchaseOrderNumber}
              fullWidth
              variant="outlined"
              value={purchaseOrder.purchaseOrderNumber}
              onChange={(e: any) =>
                setPurchaseOrder(onChangeTextField(e, purchaseOrder))
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Autocomplete
              size="small"
              id="inventory"
              freeSolo={false}
              disablePortal
              getOptionLabel={(option: any) =>
                `${option.name} - ${option.location?.name || ""}`
              }
              isOptionEqualToValue={(option, value) => option._id === value._id}
              options={inventories}
              value={purchaseOrder.inventory}
              onChange={(event: any, value: any) => {
                const newPurchaseOrder = handleChangeAutocomplete(
                  event,
                  value,
                  purchaseOrder,
                  "inventory"
                );
                newPurchaseOrder.products = [];
                newPurchaseOrder.invoice = new CostModel();
                setPurchaseOrder(newPurchaseOrder);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="inventory"
                  label={Vocabulary.inventory}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Autocomplete
              size="small"
              id="invoice"
              freeSolo={false}
              disablePortal
              disabled={purchaseOrder.inventory?._id ? false : true}
              options={invoices}
              getOptionLabel={(option: CostModel) => `${option.invoiceId}`}
              value={purchaseOrder.invoice}
              isOptionEqualToValue={(option: any, value: any) =>
                option.invoiceId === value.invoiceId
              }
              onChange={async (event: any, value: any) => {
                setPurchaseOrder({
                  ...purchaseOrder,
                  invoice: value,
                  vendor: value?.vendor || null,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="inventory"
                  label={Vocabulary.invoice}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="referenceNumber"
              name="referenceNumber"
              label={Vocabulary.referenceNumber}
              fullWidth
              variant="outlined"
              value={purchaseOrder.referenceNumber}
              onChange={(e: any) =>
                setPurchaseOrder(onChangeTextField(e, purchaseOrder))
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Autocomplete
              size="small"
              id="invoice"
              freeSolo={false}
              disablePortal
              options={vendorList}
              value={purchaseOrder.vendor}
              getOptionLabel={(option) => `${option.name}`}
              isOptionEqualToValue={(option: any, value: any) =>
                option._id === value._id
              }
              onChange={(event: any, value: any) => {
                setPurchaseOrder({
                  ...purchaseOrder,
                  vendor: value,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="inventory"
                  label={Vocabulary.vendor}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ProductsAutocomplete
              parentProduct={null}
              inventory={purchaseOrder.inventory}
              invoiceProducts={invoiceProducts}
              handleChangeProductInParent={(event: any, value: any) => {
                addNewProductInStockTransfer(event, value);
              }}
              variant="outlined"
              disabled={purchaseOrder.inventory ? false : true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={purchaseOrder.generateNir}
                  onChange={(event: any) => {
                    setPurchaseOrder({
                      ...purchaseOrder,
                      generateNir: !purchaseOrder.generateNir,
                    });
                  }}
                />
              }
              label={Vocabulary.generateNIR}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ProductsList
              products={purchaseOrder.products}
              showPrice={true}
              onChangeProducts={onChangeProducts}
              vatList={vatList}
            />
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
